import React from "react";
import "./BoardsDetailTabs.css";

const TAB_ITEMS = [
  { id: "features", label: "Features" },
  { id: "specifications", label: "Specifications" },
  { id: "recommendations", label: "Recommendations" },
  { id: "sustainability", label: "Sustainability" },
  { id: "downloads", label: "Downloads" },
];

const BoardsDetailTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="boardsDetailTabs-wrap">
      <div className="boardsDetailTabs-inner">
        <nav className="boardsDetailTabs" aria-label="Product sections">
          {TAB_ITEMS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`boardsDetailTabs-tab ${
                activeTab === tab.id ? "is-active" : ""
              }`}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default BoardsDetailTabs;
